// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__eo6dJ","formControl":"addForm_formControl__JOwg6","list":"addForm_list__GziYu","btnWrpper":"addForm_btnWrpper__eanUX"};